import type { Model } from '../../../types/mfc'
import { loungeSlugs, loungeUIDs } from '../../constants/mfcAccounts'
import { isLevelAdmin, isLevelModel, isLevelPremiumOrHigher } from './level'

/** user.level >= 2 */
export const isPremiumMember = (user: Partial<Model>) => {
    return isLevelPremiumOrHigher(user?.level)
}
/** user.level == 4 */
export const isModel = (user: Partial<Model>) => {
    return isLevelModel(user?.level)
}
/** user.level == 5 */
export const isAdmin = (user: Partial<Model>) => {
    return isLevelAdmin(user?.level)
}

export const resolveSlugFromName = (nm: string) => {
    if (typeof nm !== 'string') return ''
    return nm.toLowerCase()
}

export const isLounge = (nmOrId: string | number) => {
    if (typeof nmOrId !== 'string' && typeof nmOrId !== 'number') return false
    if (typeof nmOrId === 'number') {
        return loungeUIDs.includes(nmOrId as any)
    }
    const slug = resolveSlugFromName(nmOrId)
    return loungeSlugs.includes(slug as any)
}

export const isPreviewAvailable = ({
    isBroadcasting,
    isAway,
    banned,
    isPublicShow,
}: Pick<Model, 'isBroadcasting' | 'isAway' | 'banned' | 'isPublicShow'>) =>
    isBroadcasting && !isAway && !banned && isPublicShow
